import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { RichTextEditorWithTemplateTokens } from 'Components/ComponentLibrary/Molecules/RichTextEditorWithTemplateTokens';

const hiddenFields = ['agentId', 'templateType'];

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ hint: 'richtext' }, { _component: () => RichTextEditorWithTemplateTokens })
  .nameOverride(hiddenFields, { hidden: true });
